<template>
  <div>
    <v-layout :style="{ margin: '-16px' }" wrap>
      <v-flex class="pa-3" xs12>
        <v-layout>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn @click="handleSearchButtonClick">
              <v-icon>search</v-icon>
              Search
            </v-btn>
            <v-btn color="primary" @click="handleExportButtonClick">
              <v-icon>logout</v-icon>
              Export
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="pa-3" xs12>
        <slot name="status" v-bind="{ filter, statusStatisticData, loading }"></slot>
      </v-flex>
      <v-flex class="pa-3" xs12 md7>
        <slot name="agent" v-bind="{ filter, agentStatistics, loading }"></slot>
      </v-flex>
      <v-flex class="pa-3" xs12 md5>
        <slot name="response" v-bind="{ filter, responseStatistics, loading }"></slot>
      </v-flex>
    </v-layout>

    <StatisticsSearchDialog
      v-model="filter"
      :open.sync="statisticsSearchDialog.isOpen"
      @input="handleStatisticsSearchDialogInput"
    />
  </div>
</template>

<script>
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import StatisticsSearchDialog from './StatisticsSearchDialog.vue'
import { PAGE_GROUP } from '@/constants/page.js'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

dayjs.extend(utc)
dayjs.extend(tz)
export default {
  name: 'StatisticsVue',
  components: {
    StatisticsSearchDialog
  },
  data() {
    return {
      statisticsSearchDialog: {
        isOpen: false,
        data: {}
      },
      filter: {
        startTime: dayjs().format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
        role: '',
        channel: '',
        search_page_id: ''
      },
      statusStatisticData: undefined,
      agentStatistics: undefined,
      responseStatistics: undefined,
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService', 'customerStatusOptions']),
    statusOptions() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed without survey', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption
        } else {
          return status
        }
      }
    }
  },
  watch: {
    filter: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    this.$emit('handleChangeFilter', this.filter)
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      this.loading = true
      await this.handleGetNumberOfCaseStatus()
      await this.handleGetChatlogCountAgentBot()
      await this.handleGetAverageResponseTime()
      this.loading = false
    },
    async handleGetNumberOfCaseStatus() {
      const response = await ticket3AgentManagementApi.geNumberOfCaseStatus({
        params: {
          ...this.filter,
          start_date: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          end_date: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          page_id: this.selectedBot.pageid
        }
      })
      const statusStatisticData = this.statusOptions.reduce((acc, cur) => {
        acc[cur.value] = 0
        return acc
      }, {})
      if (response.status == 200 && response.data) {
        const data = response.data
        const dataEntity = Object.entries(data)
        for (const [key, value] of dataEntity) {
          // replace underscore with space
          const newKey = key.replace(/_/g, ' ')
          if (Object.hasOwnProperty.call(statusStatisticData, newKey)) {
            statusStatisticData[newKey] = value
          }
        }
      }
      this.statusStatisticData = statusStatisticData
    },
    async handleGetChatlogCountAgentBot() {
      const response = await ticket3AgentManagementApi.getChatlogCountAgentBot({
        params: {
          ...this.filter,
          start_date: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          end_date: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          page_id: this.selectedBot.pageid
        }
      })

      if (response.status == 200 && response.data) {
        let { admin, bot, bot_ans, admin_ans, total_ans } = response.data
        bot = bot.map((item) => {
          return {
            date: dayjs.tz(`${item.date}`, 'Asia/Bangkok').valueOf(),
            count: item.count
          }
        })

        admin = admin.map((item) => {
          return {
            date: dayjs.tz(`${item.date}`, 'Asia/Bangkok').valueOf(),
            count: item.count
          }
        })

        for (let i = 0; i < admin.length; i++) {
          if (bot.some((item) => item.date === admin[i].date)) {
            continue
          } else {
            bot.push({
              date: admin[i].date,
              count: 0
            })
          }
        }

        for (let i = 0; i < bot.length; i++) {
          if (admin.some((item) => item.date === bot[i].date)) {
            continue
          } else {
            admin.push({
              date: bot[i].date,
              count: 0
            })
          }
        }

        this.agentStatistics = {
          agentData: admin.sort((a, b) => a.date - b.date),
          botData: bot.sort((a, b) => a.date - b.date),
          bot_ans: bot_ans,
          admin_ans: admin_ans,
          total_ans: total_ans
        }
      } else {
        this.agentStatistics = {
          agentData: [],
          botData: [],
          bot_ans: 0,
          admin_ans: 0,
          total_ans: 0
        }
      }
    },
    handleStatisticsSearchDialogInput(data) {
      this.filter = {
        ...data,
        startTime: data.startTime ? data.startTime : undefined,
        endTime: data.endTime ? data.endTime : undefined,
        role: data.role ? data.role : undefined,
        channel: data.channel ? data.channel : undefined,
        search_page_id: data.search_page_id ? data.search_page_id : undefined
      }
      this.$emit('handleChangeFilter', this.filter)
    },
    async handleGetAverageResponseTime() {
      const response = await ticket3AgentManagementApi.getAverageResponseTime({
        params: {
          ...this.filter,
          start_date: this.filter.startTime
            ? dayjs(this.filter.startTime).format('YYYY-MM-DD')
            : undefined,
          end_date: this.filter.endTime
            ? dayjs(this.filter.endTime).format('YYYY-MM-DD')
            : undefined,
          page_id: this.selectedBot.pageid
        }
      })
      if (response.data.data) {
        const { data } = response.data
        this.responseStatistics = {
          received: data.recived_ticket || 0,
          resolved: data.resolved_ticket || 0,
          averageFirstResponseTime: data.first_reponse_avg || 0,
          averageResolvedTicketTime: data.resolved_avg || 0
        }
      } else {
        this.responseStatistics = {
          received: 0,
          resolved: 0,
          averageFirstResponseTime: 0,
          averageResolvedTicketTime: 0
        }
      }
      // console.log(response)
    },
    async handleExportButtonClick() {
      this.$emit('export', {
        filter: this.filter
      })
    },
    handleSearchButtonClick() {
      this.statisticsSearchDialog.isOpen = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/overview/Statistics.vue